@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.balance

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengerwallet.ExtendedPassengerWalletDto


object GetPassengerBalanceEndpoint :
    EndPoint<GetPassengerBalanceEndpoint.Request, GetPassengerBalanceEndpoint.Response>() {
    class Request

    class Response(
        val passengerBalance: ExtendedPassengerWalletDto,
    )
}